<template>
  <modal ref="modal">
    <modal-body :message="modalMessage" />
    <modal-footer>
      <restore-button @click="doRestore" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import RestoreButton from '@/views/molecules/buttons/RestoreButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';

export default {
  name: "RestoreConfirmModal",
  emits: ['restore'],
  props: {
    message: {
      type: String,
      default: "利用再開してよろしいですか？",
    },
    isDirty: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    RestoreButton,
    CancelButton,
  },
  computed: {
    modalMessage() {
      return this.message + (this.isDirty ? '\n\n編集中の内容は破棄されます。' : '');
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doRestore() {
      this.$refs.modal.hide();
      this.$emit('restore');
    },
  },
}
</script>
